import { ZealApiResponse, PersonaIDVDecisionResponse } from "@zeal/common";
import { IAxiosInstance } from "../../../AbstractApiClient/AbstractApiClient";
import { TGetPersonaDecisionRequestSchema } from "./getPersonaDecision.schema";

export const getPersonaDecision = (axios: IAxiosInstance) => {
  return async (data: TGetPersonaDecisionRequestSchema) => {
    const response = await axios.noRetry.get<
      ZealApiResponse<PersonaIDVDecisionResponse[]>
    >(`/api/getPersonaDecision`, {
      params: data,
    });

    const resData = response.data;

    if (resData.success) {
      return resData.data;
    }

    throw new Error("Something went wrong");
  };
};
